/** Run work after the browser is idle (falls back to setTimeout). Returns cleanup. */
export function scheduleIdle(fn: () => void, timeoutMs = 2000): () => void {
  let cancelled = false;
  const run = () => {
    if (!cancelled) fn();
  };

  if (typeof requestIdleCallback === "function") {
    const id = requestIdleCallback(run, { timeout: timeoutMs });
    return () => {
      cancelled = true;
      cancelIdleCallback(id);
    };
  }

  const id = window.setTimeout(run, 1);
  return () => {
    cancelled = true;
    window.clearTimeout(id);
  };
}
